import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';

@Component({
    selector: 'brover-logout',
    template: '<brover-auth-loader></brover-auth-loader>',
    standalone: false
})
export class LogoutComponent {

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private userService: UserService
  ) {
    this.localStorageService.remove('access-token');
    this.localStorageService.remove('refresh-token');

    this.userService.loggedIn.next(false);
    this.userService.user.next({});

    this.router.navigate(['/dashboard']);
  }

}
